import { ColumnType } from "antd/lib/table";
import Actions from "./components/Actions";
import { formatDateTime } from "ui/utils";
import Badge from "ui/components/badge";

export const columns: ColumnType<any>[] = [
  {
    title: "Nome",
    dataIndex: "nome",
    key: "nome",
    align: "center",
    render: (value: string) => <span>{value ?? "-"}</span>,
  },
  {
    title: "E-mail",
    dataIndex: "email",
    key: "email",
    align: "center",
    render: (value: string) => <span>{value ?? "-"}</span>,
  },
  {
    title: "Telefone",
    dataIndex: "telefone",
    key: "telefone",
    align: "center",
    render: (value: string) => <span>{value ?? "-"}</span>,
  },
  {
    title: "Data de Criação/Atualização",
    dataIndex: "dataUltimaAlteracao",
    key: "dataUltimaAlteracao",
    align: "center",
    render: (value: string) => <span>{value ? formatDateTime(value) : "-"}</span>,
  },
  {
    title: "Status",
    dataIndex: "ativo",
    key: "ativo",
    align: "center",
    render: (value: boolean) => (
      <Badge
        type={value ? "success" : "danger"}
        value={value ? "Ativo" : "Inativo"}
      />
    ),
  },
  {
    title: "Ações",
    dataIndex: "notificacaoJustificativasDestinatarioId",
    align: "center",
    render: (value: string, record: any) => (
      <Actions id={value} record={record} />
    ),
  },
];
